// getPreferredAirport.js
import { PRIORITY_AIRPORTS, airports, getAirportsByCountry } from "../utils/airportSearchNew";

// Haversine formula to calculate distance between two coordinates (in kilometers)
const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const toRad = (value) => (value * Math.PI) / 180;
  const R = 6371; // Earth's radius in kilometers
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
};

export const getPreferredAirport = (userCountry, userCoords = null) => {
  // Use the optimized getAirportsByCountry function for better performance
  const userAirports = getAirportsByCountry(userCountry);

  if (!userAirports.length) return null;

  // If one of the airports is in your priority list, return that one
  const priority = userAirports.find((airport) =>
    PRIORITY_AIRPORTS.has(airport.id)
  );
  if (priority) return priority;

  // If multiple airports exist and we have user coordinates, select the nearest one
  if (userCoords && userCoords.latitude && userCoords.longitude) {
    let nearest = userAirports[0];
    let minDistance = calculateDistance(
      userCoords.latitude,
      userCoords.longitude,
      parseFloat(nearest.latitude || 0),
      parseFloat(nearest.longitude || 0)
    );

    userAirports.forEach((airport) => {
      const airportLat = parseFloat(airport.latitude || 0);
      const airportLon = parseFloat(airport.longitude || 0);
      
      if (airportLat && airportLon) { // Only calculate if airport has coordinates
        const distance = calculateDistance(
          userCoords.latitude,
          userCoords.longitude,
          airportLat,
          airportLon
        );
        if (distance < minDistance) {
          minDistance = distance;
          nearest = airport;
        }
      }
    });
    return nearest;
  }

  // Otherwise, return the first airport in the list
  return userAirports[0];
};
